






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Form } from '@/models/Form';
import { BModal } from 'bootstrap-vue';

@Component({
    name: 'ModalFormDelete',
    components: {
        'b-modal': BModal,
    },
})
export default class ModalFormDelete extends Vue {
    error = '';
    updating = false;

    @Prop() form!: Form;

    reset() {
        this.error = '';
    }

    remove() {
        this.updating = true;
        try {
            this.$store.dispatch('forms/delete', this.form);
            this.$bvModal.hide(`modalFormDelete-${this.form.id}`);

            if (this.$router.currentRoute.name === ('form_elements' || 'report_elements' || 'entries')) {
                this.$router.replace('/forms');
            }
        } catch (e) {
            this.error = e;
        } finally {
            this.updating = false;
        }
    }
}
